export const en = {
  pageTitle: "Reports",
  dateRange: { from: "From", to: "To" },
  filters: {
    triggerTypeAriaLabel: "Filter by trigger type",
    allTriggers: "All Triggers",
  },
  export: {
    fileName: "activity-report.csv",
    csvButton: "Export CSV",
    errorTitle: "Export failed",
    errorDescription: "Could not download the CSV report. Please try again.",
    columns: {
      activityId: "Activity ID",
      triggerType: "Trigger Type",
      sourceReference: "Source Reference",
      status: "Status",
      outcome: "Outcome",
      priority: "Priority",
      value: "Value",
      currency: "Currency",
      assigneeEmail: "Assignee Email",
      createdAt: "Created At",
    },
  },
  kpi: {
    activitiesCreated: "Activities Created",
    completed: "Completed",
    completionRate: "Completion Rate",
    vsPrevPeriod: "vs prev period",
  },
  volume: {
    title: "Daily Activity Volume",
    loadingSubtitle: "Loading activity data...",
    days: "days",
    empty: {
      title: "No activity data",
      description: "Try adjusting the date range to see results",
      subtitle: "No data for selected period",
    },
    tooltip: {
      created: "Created",
      completed: "Completed",
      total: "Total",
      completionRate: "Completion Rate",
      vsPreviousDay: "vs Previous Day",
    },
    stats: {
      total: "Total",
      totalTip: "Total activities in period",
      created: "Created",
      createdTip: "Activities created in period",
      completed: "Completed",
      completedTip: "Activities completed in period",
      avgPerDay: "Avg/day",
      avgPerDayTip: "Average total activities per day",
      rate: "Rate",
      rateTip: "Overall completion rate",
      peak: "Peak",
      peakWithDate: "Peak ({{date}})",
      peakTip: "Busiest day in period",
    },
    legend: { created: "Created ", completed: "Completed " },
    axis: { activities: "Activities" },
    refLine: { avgPerDay: "Avg {{n}}/day" },
    bar: { created: "Created", completed: "Completed" },
  },
  repsTable: {
    title: "Top Reps",
    empty: "No rep data available",
    col: { rep: "Rep", completed: "Completed", assigned: "Assigned", rate: "Rate" },
  },
  outcomes: {
    title: "Outcomes Distribution",
    loadingSubtitle: "Loading outcome data...",
    group: { completed: "Completed", rejected: "Rejected", warning: "Warning", inProgress: "In Progress", other: "Other" },
    collapsedMore: "Other ({{n}} more)",
    sort: { byCount: "By Count", byGroup: "By Group" },
    pills: {
      total: "Total",
      totalTip: "Total completed activities with outcomes",
      successRate: "Success Rate",
      successRateTip: "Confirmed + Recovered + Converted / Total",
      top: "Top",
      topTip: "Most common outcome ({{n}})",
      categories: "Categories",
      categoriesTip: "Distinct outcome types in period",
    },
    row: { topBadge: "Top", collapsedBadge: "collapsed" },
    tooltip: {
      rank: "#{{rank}}",
      shareOfTotal: "{{pct}}% of {{total}} total",
      groupOutcome: "{{group}} outcome",
    },
    empty: {
      title: "No outcome data",
      description: "Completed activities will appear here",
      subtitle: "No data for selected period",
    },
    subtitle: { outcomes: "{{n}} outcomes", categories: "{{n}} categories", acrossJoiner: " across " },
  },
  topReps: {
    title: "Top Reps Performance",
    loadingSubtitle: "Loading rep data...",
    metric: { completed: "Completed", rate: "Rate" },
    tooltip: { rank: "#{{rank}}", completed: "Completed", assigned: "Assigned", rate: "Rate" },
    teamAverage: "Team Average",
    completedWord: "completed",
    rateWord: "rate",
    totalWord: "total",
    empty: {
      title: "No rep data",
      description: "Assigned reps will appear here",
      subtitle: "No data for selected period",
    },
    subtitle: "{{repCount}} reps · {{total}} total completed",
  },
} as const;
